import { atomWithStorage } from 'jotai/utils';

import { createCookieStorage } from '../../Utils/CookieStorage';
import { normalizePostcode } from '../../Utils/NormalizePostcode';

const defaultValue = '';

const postcodeStorage = createCookieStorage<string>(defaultValue);

const postcodeStorageWithLegacyFallback = {
  ...postcodeStorage,
  getItem: (key: string, initialValue: string) =>
    normalizePostcode(postcodeStorage.getItem(key, initialValue)),
};

export const postcodeAtom = atomWithStorage<string>(
  'postcodeValue',
  defaultValue,
  postcodeStorageWithLegacyFallback,
);
